<!--报表 历史入库单-->
<template>
  <div class="page-container">
    <div class="filter-bar">
      <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium">
        <el-form-item label="产品名称：">
          <el-input v-model="searchForm.PRODUCT_NAME" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="产品编码：">
          <el-input v-model="searchForm.PRODUCT_CODE" clearable></el-input>
        </el-form-item>
        <el-form-item label="批次：">
          <el-input v-model="searchForm.BATCH" clearable></el-input>
        </el-form-item>
        <el-form-item label="订单ID：">
          <el-input v-model="searchForm.ORDER_ID" clearable></el-input>
        </el-form-item>
        <el-form-item label="供应商：">
          <el-select filterable v-model="searchForm.TC_COMPANY" placeholder="请选择供应商" :clearable="true">
            <el-option v-for="item in companys" :key="item.SUPPLIER_ID" :label="item.AB_NAME"
              :value="item.SUPPLIER_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入库日期：">
          <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="生产日期：">
          <el-date-picker v-model="searchForm.PRODUCTION_DATE" type="date" value-format="yyyy-MM-dd"
            style="width: 200px"></el-date-picker>
        </el-form-item>
        <el-form-item label="订单日期">
          <el-date-picker v-model="searchForm.DAY_ORDER" type="daterange" align="right" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="打印次数：">
          <el-input v-model="searchForm.PRINT_TIME" placeholder="请输入内容" oninput="value=value.replace(/[^0-9]/g,'')"
            clearable style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="btn" @click="search" :loading="loading">筛选</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="manualInsotckDetail()">手动入库记录</el-button>
          <el-button type="primary" plain class="btn" @click="exportData" v-if="fun_dic[113010103]">
            入库单导出
          </el-button>
          <el-button type="primary" plain @click="exportPdf()" v-show="fun_dic[113010102]">
            导出PDF
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="summary-bar">
      <span>总金额：{{ TOTAL_FEE }}</span>
      <span>入库总金额：{{ REAL_TOTAL_WORTH }}</span>
    </div>
    <div class="table-wrapper" style="flex: 1; overflow: hidden;">
      <el-table border stripe :data="tableData" height="100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>

        <el-table-column prop="ORDER_ID" label="订单ID" min-width="70px"></el-table-column>
        <el-table-column prop="CREATE_TIME" label="入库日期" min-width="70px"></el-table-column>
        <el-table-column prop="SEND_DAY" label="订单日期" min-width="70px"></el-table-column>
        <el-table-column prop="ORDER_CODE" label="订单编号"></el-table-column>
        <el-table-column prop="NAME" label="供应商"></el-table-column>
        <el-table-column prop="TOTAL_WORTH" label="总价值"></el-table-column>
        <el-table-column prop="REMARKS" label="备注"></el-table-column>
        <el-table-column prop="PRINT_TIME" label="打印次数" width="100px"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="detail(scope.row)">查看</el-button>
            <el-button size="small" type="text" @click="exportDetail(scope.row)">导出</el-button>
            <el-button type="text" size="small" @click="print(scope.row, '打印')">打印</el-button>
            <el-button type="text" size="small" @click="print(scope.row, '短打印')">短打印</el-button>
            <el-button type="text" size="small" @click="changDate(scope.row)"
              v-show="fun_dic[113010101]">入库日期调整</el-button>
            <el-button size="small" type="text" @click="downloadFile(scope.row)"
              v-if="scope.row.FILE_NAME">下载入库单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <el-dialog title="是否打印编码" center :visible.sync="previewVisible" width="400px">
      <el-radio style="margin: 0px 80px 0 90px" v-model="IsPrintCode" label="1">是</el-radio>
      <el-radio v-model="IsPrintCode" label="0">否</el-radio>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAll">取 消</el-button>
        <el-button @click="preview" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="入库日期调整" center :visible.sync="printSelfSetFormVisible" width="500px">
      <el-form ref="returnAuditForm" :model="returnAuditForm" style="padding-left: 20px;">
        <el-form-item label="调整日期">
          <el-date-picker v-model="returnAuditForm.CREATE_TIME" type="date" placeholder="选择日期时间"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="printSelfSetFormVisible = false">取 消</el-button>
        <el-button @click="submitPrintSelf">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { historyInFun, exportInStockData, exportRowDetail } from 'api/warehouseManager';
import { supplierList } from 'api/systemSetting';
import { getActionFun } from 'api/login';
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data () {
    return {
      PAGE_ID: '1130101',
      fun_dic: { 113010101: 0, 113010102: 0, 113010103: 0 },
      companys: [],
      loading: false,
      printSelfSetFormVisible: false,
      // loadExport: false,
      searchForm: {
        DAY_INTERVAL: [],
        DAY_ORDER: [date(new Date(), '%F'), date(new Date(), '%F')],
      },
      returnAuditForm: {},
      tableData: [],
      totalCount: 0,
      pageSize: 15,
      currentPage: 1,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      IsPrintCode: '0',
      previewVisible: false,
      rowDetail: {},
      printType: '',
      TOTAL_FEE: 0,
      REAL_TOTAL_WORTH: 0,

    };
  },
  created () {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.HISTORY_IN_DATA_CONDITION.CONDITION) {
      this.searchForm = this.HISTORY_IN_DATA_CONDITION.CONDITION;
      this.currentPage = this.HISTORY_IN_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
    this.queryGYSData();
    this.queryBeforeFun();
  },
  computed: {
    HISTORY_IN_DATA_CONDITION () {
      return this.$store.state.HISTORY_IN_DATA_CONDITION;
    },
  },
  methods: {
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    changDate (row) {
      this.printSelfSetFormVisible = true;
      this.returnAuditForm = JSON.parse(JSON.stringify(row));
      this.returnAuditForm.CREATE_TIME = row.CREATE_TIME.split(' ')[0];
    },
    submitPrintSelf () {
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 98,
        ORDER_ID: this.returnAuditForm.ORDER_ID,
        RECORD_ID: this.returnAuditForm.ID,
        NEW_DAY: this.returnAuditForm.CREATE_TIME,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '调整成功', type: 'success' });
        this.printSelfSetFormVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------导出
    exportData () {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          if (!((this.searchForm.DAY_ORDER != null && this.searchForm.DAY_ORDER.length == 2) || (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2))) {
            this.$message.show({ text: '请至少选择入库日期或订单日期中的一项', type: 'warning' });
            return;
          }
          const params = {};
          if (this.searchForm.DAY_ORDER != null && this.searchForm.DAY_ORDER.length == 2) {
            params.START_SEND_DAY = this.searchForm.DAY_ORDER[0];
            params.END_SEND_DAY = this.searchForm.DAY_ORDER[1];
          }
          if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
            params.START_DATE = this.searchForm.DAY_INTERVAL[0];
            params.END_DATE = this.searchForm.DAY_INTERVAL[1];
          }
          if (this.searchForm.TC_COMPANY) {
            params.VENDOR_ID = this.searchForm.TC_COMPANY;
          }
          exportInStockData(params).then((result) => {
            if (result[0] && result[0].TASK_CREATED_SUCCESSFULLY) {
              this.$util.getUnreadInformation(this);
              this.$confirm(this.$util.appointmentMessage, '温馨提示', {
                confirmButtonText: '确定', cancelButtonText: '取消', type: 'success', dangerouslyUseHTMLString: true,
              }).then(() => {
                this.$router.push({ name: 'appointmentHandling' });
              }).catch(() => {
                this.$message.show({ type: 'info', text: '取消操作' });
              });
            } else {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            }
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    // ----------------导出PDF
    exportPdf () {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10031',
            OTYPE: 100,
            GYS_ID: sessionStorage.getItem('tcId'),
          };
          if (this.searchForm.DAY_ORDER != null && this.searchForm.DAY_ORDER.length == 2) {
            params.START_SEND_DAY = this.searchForm.DAY_ORDER[0];
            params.END_SEND_DAY = this.searchForm.DAY_ORDER[1];
          }
          if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
            params.START_DAY = this.searchForm.DAY_INTERVAL[0];
            params.END_DAY = this.searchForm.DAY_INTERVAL[1];
          }
          if (this.searchForm.TC_COMPANY) {
            params.VENDOR_ID = this.searchForm.TC_COMPANY;
          }
          http.post(params)
            .then((result) => {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally { }
      }
    },
    queryGYSData () {
      const params = {
        PAGEINDEX: 0,
        PAGESIZE: 9999,
      };
      supplierList(params).then((result) => {
        if (result.length !== 0) {
          this.companys = result[0].list;
        } else {
          this.companys = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 打印
    print (row, type) {
      this.previewVisible = true;
      this.rowDetail = row;
      this.printType = type;
    },
    closeAll () {
      this.previewVisible = false;
    },
    // 供应商客户打印
    preview () {
      if (this.printType == '打印') {
        this.historyPrint(this.rowDetail);
      } else if (this.printType == '短打印') {
        this.shortHistoryPrint(this.rowDetail);
      }
    },
    historyPrint (row) {
      this.$router.push({ name: 'historyPrint' });
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('IN_WAREHOUSE_RECORD_ID', row.ID);
      sessionStorage.setItem('IsPrintCode', this.IsPrintCode);
    },
    shortHistoryPrint (row) {
      this.$router.push({ name: 'historyStorageShortPrint' });
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('IN_WAREHOUSE_RECORD_ID', row.ID);
      sessionStorage.setItem('IN_WAREHOUSE_CREATE_TIME', row.CREATE_TIME);
      sessionStorage.setItem('IsPrintCode', this.IsPrintCode);
    },
    // -----------------------------拉取数据
    queryData () {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.DAY_ORDER != null && this.searchForm.DAY_ORDER.length == 2) {
        params.START_SEND_DAY = this.searchForm.DAY_ORDER[0];
        params.END_SEND_DAY = this.searchForm.DAY_ORDER[1];
      }
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.TC_COMPANY) {
        params.VENDOR_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.BATCH) {
        params.BATCH = this.searchForm.BATCH;
      }
      if (this.searchForm.ORDER_ID) {
        params.ORDER_ID = this.searchForm.ORDER_ID;
      }
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      if (this.searchForm.PRODUCTION_DATE) {
        params.PRODUCTION_DATE = this.searchForm.PRODUCTION_DATE;
      }
      if (this.searchForm.PRINT_TIME) {
        params.PRINT_TIME = this.searchForm.PRINT_TIME;
      }
      this.loading = true;
      historyInFun(params).then((result) => {
        if (result.length != 0) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
          this.TOTAL_FEE = result[0].TOTAL_FEE;
          this.REAL_TOTAL_WORTH = result[0].REAL_TOTAL_WORTH;
          this.$store.dispatch('SET_HISTORY_IN_DATA_CONDITION', {
            CONDITION: this.searchForm,
            DATA: this.tableData,
            TOTAL_COUNT: this.totalCount,
            CURRENT_PAGE: this.currentPage,
            TOTAL_FEE: this.TOTAL_FEE,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.TOTAL_FEE = 0;
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ---------------------------查看
    detail (row) {
      this.$router.push({ path: '/historyInDetail/detail' });
      sessionStorage.setItem('ORDER_ID', row.ORDER_ID);
      sessionStorage.setItem('RECORD_ID', row.ID);
    },
    // ---------------------------筛选
    search () {
      this.currentPage = 1;
      if (!((this.searchForm.DAY_ORDER != null && this.searchForm.DAY_ORDER.length == 2) || (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2))) {
        this.$message.show({ text: '请至少选择入库日期或订单日期中的一项', type: 'warning' });
        return;
      }
      this.queryData();
    },
    handleCurrentChange (e) {
      this.currentPage = e;
      this.queryData();
    },
    manualInsotckDetail () {
      this.$router.push({ name: 'manualInstockDetail' });
    },
    // 导出
    async exportDetail (row) {
      const params = {
        ORDER_ID: row.ORDER_ID,
      };
      const filepath = await exportRowDetail(params);
      window.location.href = filepath[0].FILE_PATH;
    },
    downloadFile ({ FILE_NAME }) {
      window.open(this.$util.getURLLocalHost(`/file/scmStockInFile/${FILE_NAME}`));
    },
  },
};
</script>
<style scoped>
/* 页面根容器：建立完整的高度链 */
.page-container {
  display: flex;
  flex-direction: column;
  /* 关键：calc(100vh - 头部51px - 面包屑约50px - 内边距20px) */
  height: calc(100vh - 180px);
  overflow: hidden;
  /* 防止内容溢出 */
}

/* 筛选栏和分页：固定区域 */
.filter-bar {
  flex-shrink: 0;
  /* 不被压缩 */
}

.summary-bar {
  flex-shrink: 0;
  height: 24px;
  /* 固定行高，防止数字变化时抖动 */
  line-height: 24px;
  margin: 8px 0;
}

.pagination_box {
  flex-shrink: 0;
  min-height: 32px;
  /* 分页固定高度 */
  text-align: right;
  padding: 4px 0;
}

/* 表格包裹区：核心！撑满所有剩余空间 */
.table-wrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* 防止溢出到外部 */
}
</style>



// WEBPACK FOOTER //
// src/components/tableManage/historyInStock.vue